// TODO: type this — Vuex action context
type Ctx = any;

interface ErrorState {
    modalMessage: string;
    closeCallback: (() => void) | null;
}

const ErrorStore = {
    namespaced: true,
    state: (): ErrorState => ({
        modalMessage: '',
        closeCallback: null,
    }),
    mutations: {
        setModal(
            state: ErrorState,
            { message, closeCallback }: { message: string; closeCallback: (() => void) | null },
        ): void {
            state.modalMessage = message;
            state.closeCallback = closeCallback;
        },
    },
    actions: {
        close({ state, commit }: Ctx): void {
            const cb = state.closeCallback;
            commit('setModal', { message: '', closeCallback: null });
            if (cb) cb();
        },
        modal(
            { commit }: Ctx,
            { message, closeCallback = null }: { message: string; closeCallback?: (() => void) | null },
        ): void {
            commit('setModal', { message, closeCallback });
        },
    },
};

export default ErrorStore;
